(() => {
  const key = 'kb-artwork-enquiry-context';
  // Keep only public artwork context through Shopify's challenge navigation.
  // A receipt is shown only when Liquid reports a successful submission.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.elements.form_type?.value !== 'contact') return;
    const title = form.elements['contact[Artwork]']?.value;
    const url = form.elements['contact[Artwork URL]']?.value;
    try {
      sessionStorage.removeItem(key);
      if (title && url) sessionStorage.setItem(key, JSON.stringify({ title: form.elements['contact[Artwork title]']?.value || title, artist: form.elements['contact[Artist]']?.value || '', url, time: Date.now(), preorder: form.classList.contains('ivan-preorder-dialog__form') }));
    } catch { /* Native submission still works when storage is unavailable. */ }
  }, true);

  const popup = document.querySelector('[data-receipt-popup]');
  if (popup && typeof popup.showModal === 'function') {
    // The dialog is emitted by Liquid only after Shopify confirms success.
    // Neither a stored context nor a completed CAPTCHA can trigger it.
    popup.removeAttribute('open');
    popup.showModal();
    const close = popup.querySelector('[data-receipt-close]');
    close.hidden = false;
    close.addEventListener('click', () => popup.close());
    popup.querySelector('h2').focus();
  }
  const receipt = popup?.querySelector('[data-collector-receipt]') || document.querySelector('[data-collector-receipt]');
  if (!receipt) return;
  try {
    const context = JSON.parse(sessionStorage.getItem(key) || 'null');
    sessionStorage.removeItem(key);
    if (!context || Date.now() - context.time > 30 * 60 * 1000) return;
    const url = new URL(context.url, location.origin);
    if (url.origin !== location.origin || !/^\/(products|pages)\//.test(url.pathname)) return;
    if (popup) {
      receipt.querySelector('[data-receipt-return]').href = context.artist === 'Ivan Pokidyshev' ? '/collections/ivan-pokidyshev' : url.pathname;
      return;
    }
    const artwork = receipt.querySelector('[data-receipt-artwork]');
    receipt.querySelector('[data-receipt-title]').textContent = context.title;
    receipt.querySelector('[data-receipt-artist]').textContent = context.artist || '';
    artwork.hidden = false;
    receipt.querySelector('[data-receipt-message]').textContent = 'We’ll email you about availability, pricing and delivery.';
    receipt.querySelector('[data-receipt-note]').hidden = !context.preorder;
    const link = receipt.querySelector('[data-receipt-return]');
    const isIvan = context.artist === 'Ivan Pokidyshev';
    link.href = isIvan ? '/collections/ivan-pokidyshev' : url.pathname;
    link.querySelector('[data-receipt-link-label]').textContent = isIvan ? 'Explore Ivan’s works' : 'Return to the artwork';
  } catch { /* The server-confirmed generic receipt remains available. */ }
})();
